<template>
  <v-card
    :height="widgetHeight"
    :min-width="widgetWidth"
    class="ma-0 pa-0"
    :loading="loading"
  >
    <v-card-title v-if="!loading" class="pa-0 ma-0">
      <widget-header
        :title="title"
        color="blue"
        icon="mdi-chart-timeline-variant"
      >
        <template slot="actions">
          <v-tooltip top>
            <template v-slot:activator="{ on }">
              <v-icon
                v-on="on"
                class="mr-2"
                @click.prevent="refresh"
                >mdi-refresh</v-icon
              >
            </template>
            <span>{{ $t("Refresh") }}</span>
          </v-tooltip>
          <v-tooltip top v-if="enableEdit">
            <template v-slot:activator="{ on }">
              <v-icon
                v-on="on"
                class="mr-2"
                @click.prevent="showSettings"
                >mdi-cog</v-icon
              >
            </template>
            <span>{{ $t("Settings") }}</span>
          </v-tooltip>
          <v-tooltip top v-if="enableEdit">
            <template v-slot:activator="{ on }">
              <v-icon
                v-on="on"
                class="mr-2"
                @click.prevent="removeWidget"
                >mdi-delete</v-icon
              >
            </template>
            <span>{{ $t("Delete") }}</span>
          </v-tooltip>
        </template>
      </widget-header>
    </v-card-title>
    <v-card-text class="pa-0 ma-0">
      <div
        :style="{
          'max-height': contentHeight + 'px',
          'max-width': contentWidth + 'px',
        }"
        class="overflow-y-auto ma-1 py-1"
      >
        <apexchart
          id="line-chart"
          v-if="!loading"
          type="line"
          :options="chartOptions"
          :series="series"
          :height="contentHeight - 30"
          class="ma-0 pa-0"
        ></apexchart>
      </div>
      <WidgetSettingsModal :ref="modalKey" @on-save="onSettingsSave" />
    </v-card-text>
  </v-card>
</template>

<script>
import WidgetService from "@/services/WidgetService";
import WidgetHeader from "@/components/widgets/WidgetHeader";
import WidgetSettingsModal from "@/components/widgets/WidgetSettingsModal";
import WidgetSettings from "@/ecm/models/WidgetSettings";
import VueApexCharts from "vue-apexcharts";
import { mapGetters } from "vuex";

export default {
  components: { WidgetHeader, WidgetSettingsModal, apexchart: VueApexCharts },
  name: "WidgetLineChart",
  props: {
    widgetId: {
      type: Number,
      default: 0,
    },
    id: {
      type: Number,
      default: 0,
    },
    enableEdit: {
      type: Boolean,
      default: false,
    },
    height: { type: Number, default: 0 },
    width: { type: Number, default: 0 },
    settings: { type: Object },
  },
  mounted() {
    this.widgetHeight = this.height;
    this.widgetWidth = this.width;
    this.settingsModel = new WidgetSettings(this.widgetId, this.settings);
    this.refresh();

    this.connection = $.hubConnection(this.apiUrl);
    this.connection.qs = { access_token: this.token };
    var notificationHub = this.connection.createHubProxy("notificationHub");
    let self = this;
    notificationHub.on("refresh", (notifications) => {
      clearTimeout(this.timeout);
      this.timeout = setTimeout(self.refresh, 5000);
    });
    this.connection.start();
  },
  destroyed() {
    if (this.connection) {
      this.connection.stop();
      this.connection = null;
    }
  },
  data() {
    return {
      connection: null,
      title: "",
      loading: false,
      headerHeight: 66,
      widgetHeight: 0,
      widgetWidth: 0,
      settingsModel: new WidgetSettings(),
      modalKey: "modalSettingsKey",
      chartOptions: {
        chart: {
          height: this.contentHeight,
          type: "line",
          zoom: {
            enabled: false,
          },
        },
        dataLabels: {
          enabled: true,
        },
        tooltip: {
          enabled: false,
        },
        toolbar: {
          show: false,
        },
        colors: ["#00cae3"],
        stroke: {
          curve: "straight",
        },
        xaxis: {
          categories: [],
        },
        yaxis: {
          min: 0,
          forceNiceScale: true,
        },
      },
      series: [],
    };
  },
  computed: {
    ...mapGetters({
      user: "account/user",
      apiUrl: "account/apiUrl",
      token: "account/token",
      userContentTypes: "account/userContentTypes",
    }),
    modalSettings() {
      return this.$refs[this.modalKey];
    },
    contentHeight() {
      return this.widgetHeight - this.headerHeight;
    },
    contentWidth() {
      return this.widgetWidth - 20;
    },
  },
  methods: {
    resize(height, width) {
      this.widgetHeight = height;
      this.widgetWidth = width;
      this.refresh();
    },
    refresh() {
      const params = this.getSettings();

      this.loading = true;

      WidgetService.getData(params).then((data) => {
        this.title = this.$t("WidgetLoadedDocumentTitle");

        if (data.length > 0) {
          this.title += `: ${data[0].Total}`;
          const series = [];
          const labels = [];

          data.forEach((element) => {
            series.push(element.SeriesValueY_AsInt);
            labels.push(element.SeriesValueX_AsString);
          });

          this.chartOptions.xaxis.categories = labels;
          this.series = [{ name: this.$t("Documents"), data: series }];
        }

        this.loading = false;
      });
    },
    getSettings() {
      return {
        WidgetID: this.widgetId,
        Id: this.id,
        Settings: this.settingsModel.toDto(),
      };
    },
    showSettings() {
      this.modalSettings.show(
        this.id,
        this.widgetId,
        this.settingsModel.toDto()
      );
    },
    onSettingsSave(dto) {
      this.settingsModel = new WidgetSettings(this.widgetId, dto);
      this.refresh();
    },
    removeWidget() {
      this.$emit("on-remove-widget", this.id);
    },
  },
};
</script>